export const measurementFillColor = "rgba(0, 191, 255, 0.15)";
export const measurementPointColor = "rgba(0, 191, 255, 0.75)";
export const measurementLineColor = "rgba(255, 255, 0, 1)";
export const measurementInactiveFillColor = "rgba(0, 191, 255, 0.075)";
export const measurementInactivePointColor = "rgba(0, 191, 255, 0.25)";
export const measurementInactiveLineColor = "rgba(255, 255, 0, 0.4)";
export const hoverFillColor = "rgba(0, 170, 200, 0.3)";
export const hoverLineColor = "rgba(255, 165, 0, 1)";

/**
 * The measured line itself and the label sitting on it, shared by every tool that presents a
 * measurement as "three axes plus the hypotenuse" so they read as one thing.
 */
export const measureLineColor = "#00DB2C";
export const measureLineLabelBgColor = "#000";
export const measureLineLabelTextColor = "#FFFFFF";
export const measurePointFillColor = "#092A25";
export const measurePointStrokeColor = "#0F3";

/** Per-axis colours for that decomposition, keyed by the draw part names the measure API emits. */
export const axisColors = {
    "x-axis": { line: "#F00", labelBg: "#570F0F", labelText: "#F7D4DA" },
    "y-axis": { line: "#005DFF", labelBg: "#0D2959", labelText: "#D2E0F9" },
    "z-axis": { line: "#E5FF00", labelBg: "#4D5500", labelText: "#F9FFBB" },
} as const;

export type AxisPartName = keyof typeof axisColors;

export function isAxisPartName(name: string | undefined): name is AxisPartName {
    return name === "x-axis" || name === "y-axis" || name === "z-axis";
}
